import {jwtServerInstance} from "../index";
import qs from	'qs'


export const addReplaceOrderLimit = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/replaceadd',
        method:'post',
        data:dialogForm
    })
}

export const getAllOrderLimit = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/query',
        method:'post'
    });
}

export const addOrUpdateBusinessSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addbbssetting',
        method:'post',
        data:dialogForm
    })
}

export const queryBusinessSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querybbsetting',
        method:'post'
    });
}

export const addOrUpdateSalemanSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addsbssetting',
        method:'post',
        data:dialogForm
    })
}

export const querySalemanSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querysbsetting',
        method:'post'
    });
}

export const addOrUpdateCustomerSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addscssetting',
        method:'post',
        data:dialogForm
    })
}

export const queryCustomeSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/queryscsetting',
        method:'post'
    });
}

export const addOrUpdateOrderSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addossetting',
        method:'post',
        data:dialogForm
    })
}

export const queryOrderSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/queryosetting',
        method:'post'
    });
}

export const addOrUpdateSmsSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addsmssetting',
        method:'post',
        data:dialogForm
    })
}

export const querySmsSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querysmssetting',
        method:'post'
    });
}

export const addOrUpdateBackCardSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addbcardsetting',
        method:'post',
        data:dialogForm
    })
}

export const queryBackCardSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querybcardsetting',
        method:'post'
    });
}

export const addOrUpdateCashOutSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addcashosetting',
        method:'post',
        data:dialogForm
    })
}

export const queryCashOutSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querycashosetting',
        method:'post'
    });
}

export const addOrUpdateVerifyPhoneSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addverifynsetting',
        method:'post',
        data:dialogForm
    })
}

export const queryVerifyPhoneSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/queryverifynsetting',
        method:'post'
    });
}

export const addOrUpdateSettletSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/addsettletsetting',
        method:'post',
        data:dialogForm
    })
}

export const querySettletSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querysettletsetting',
        method:'post'
    });
}


export const queryLoginBackgroundImage = (domain) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/loginbgimage',
        method:'post',
        data: qs.stringify({
            domain: domain
        })
    })
}

export const queryOwnerNameWithDomain = (domain) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/ownernamewithdomain',
        method:'post',
        data: qs.stringify({
            domain: domain
        })
    })
}

export const queryThemeStyleInfo = (domain) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/querytheme',
        method:'post',
        data: qs.stringify({
            domain: domain
        })
    })
}
